import { useDispatch, useSelector } from "react-redux";
import HeadingTitle from "../headingTitle/HeadingTitle";
import "./AudioVideo.scss";
import { useEffect, useState } from "react";
import { getPosts } from "../../redux/features/post/postSlice";

import DOMPurify from "dompurify";
import { shortenText } from "../../utils";

const AudioVideo = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [videoPlayer, setVideoPlayer] = useState("");

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  const { posts, isLoading, error } = useSelector((state) => state.post);

  useEffect(() => {
    if (!isLoading && posts?.length > 0) {
      const audioVideo = posts.find((post) => post.category === "Audio Video");
      setVideoPlayer(audioVideo?.link || "");
    }
  }, [isLoading, posts]);

  const audioVideo = posts?.find((post) => post?.category === "Audio Video");
  const audioVideoSide = posts
    ?.filter((av) => av?.category === "Audio Video")
    ?.slice(0, 4); // Slice for limiting to 4 items

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading posts!</div>;
  }

  return (
    <div className="audioVideo">
      <div className="audioVideoWrapper">
        <HeadingTitle title="Audio &amp; Video" />

        <div className="body">
          <div className="videoWrapper">
            {videoPlayer ? (
              <iframe
                src={videoPlayer}
                sandbox="allow-scripts allow-same-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; loop"
                title={audioVideo?.title}
                width="560"
                height="315"
                frameBorder="0" // Updated to frameBorder
              ></iframe>
            ) : (
              <div>No video available</div>
            )}
          </div>
          <div className="listWrapper">
            <div className="list">
              {audioVideoSide?.map((av) => {
                const date = new Date(av?.createdAt);
                const formattedDate = date.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                });

                return (
                  <div
                    className="item"
                    key={av._id}
                    onClick={(e) => {
                      e.preventDefault();
                      setVideoPlayer(av.link);
                    }}
                  >
                    <div className="left">
                      <img src={av.image} alt={av.title} />
                    </div>
                    <div className="right">
                      <ul className="nav">
                        <li>{av.type}</li>
                        <li>{formattedDate}</li>
                      </ul>
                      <h3
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            shortenText(av?.title, 90)
                          ),
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioVideo;
